<template>
  <ion-toolbar></ion-toolbar>
  <div class="main_wrapper ion-padding ">

    <div v-if="stripeConnectStatus !== null">
      <template v-if="stripeConnectStatus === true">
        <div class="page_title">Congratulations</div>
        <div class="form_text">
          <div class="text mt-3">
            Your account has been connected successfully
          </div>
        </div>
      </template>
      <template v-else>
        <div class="page_title">Fail</div>
        <div class="form_text">
          <div class="text">
            Registration failed or was not completed. Please try again.
          </div>
        </div>
        <div v-if="stripeConnectStatus === false && !userData.id" class="form_text">
          <div class="text">
            You have to login to continue onboarding
          </div>
        </div>
      </template>
    </div>

    <div v-if="stripeConnectStatus === false && userData.id" class="mt-3">
      <button @click="refresh" class="el-button el-button--blue full-width">
        Continue to connect
      </button>
    </div>

    <div class="mt-3">
      <button @click="back" class="el-button el-button--blue full-width">
        Back to app
      </button>
    </div>


  </div>
</template>

<style scoped lang="scss">
.full-width {
  width: 100%;
}
</style>

<script>
import {onMounted, computed} from "vue";
import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {IonToolbar} from "@ionic/vue";
import {useStore} from "vuex";

import {useRoute, useRouter} from "vue-router";
// import { ref } from "@vue/reactivity";

export default {
  components: {
    IonToolbar,
  },

  async beforeMount() {
    const route = useRoute();
    const $store = useStore();
    await $store.dispatch("GET_STRIPE_STATUS", route.query);
  },

  setup() {
    const $store = useStore();
    const $router = useRouter();

    const userData = $store.getters.GET_USER_DATA;

    onMounted(async () => {
    });

    const stripeConnectStatus = computed(() => {
      console.log('stripeConnectStatus -> ', $store.getters.stripeConnectStatus);
      return $store.getters.stripeConnectStatus;
    });


    const back = () => {
      $router.push({
        name: "search",
      });
    };

    const refresh = async () => {
      await $store.dispatch("GET_STRIPE_REFRESH");
      let link = document.createElement("a");
      const url = $store.getters.stripeRefreshLink;
      link.setAttribute("href", url);
      link.click();
    };

    return {
      refresh,
      stripeConnectStatus,
      back,
      userData
    };
  },
};
</script>
